import { GeoJsonLayer } from "@deck.gl/layers";

import type { LabelGeoJSON, Location } from "~/lib/map/types";
import { geoJsonsToCharacterSet } from "./geoJsonsToCharacterSet";
import { locationToLabelGeoJson } from "./locationToLabelGeoJson";

export const initLocationsLayer = (locations: Location[], onLocationClick: (location: Location) => void) => {
  const labelGeoJsons = locations.map((location) => locationToLabelGeoJson(location));

  return new GeoJsonLayer({
    id: "locations-layer",
    data: labelGeoJsons,
    pickable: true,
    onClick: (info) => {
      if (info.object) {
        const coords = info.object.geometry.coordinates as [number, number];
        onLocationClick({
          coords: { lat: coords[1], lng: coords[0] },
          label: info.object.properties.label ?? "",
          geoItemId: info.object.properties.geoItemId,
        });
      }
    },
    stroked: true,
    filled: true,
    pointType: "circle+text",

    // point and line
    getLineWidth: 3,
    lineWidthUnits: "pixels",
    getPointRadius: 5,
    pointRadiusUnits: "pixels",
    getFillColor: [0, 0, 0, 200],
    getLineColor: [255, 255, 255, 200],

    // text
    getText: (d: LabelGeoJSON) => d.properties.label ?? null,
    getTextColor: [20, 20, 20],
    textFontFamily: "system-ui,SFMono-Regular,Menlo,Monaco,Consolas,monospace",
    getTextSize: 16,
    textSizeScale: 0.6,
    textFontWeight: 600,
    textLineHeight: 1,
    textBackground: true,
    textBackgroundPadding: [6, 4],
    // A location without a label is drawn as the dot alone; without this the empty text still paints its
    // padded background box.
    getTextBackgroundColor: (d: LabelGeoJSON) => (d.properties.label ? [255, 255, 255, 180] : [0, 0, 0, 0]),
    getTextPixelOffset: [0, -18],
    textCharacterSet: geoJsonsToCharacterSet(labelGeoJsons),
  });
};
